import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Features() {
    const {data : {home: {features : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="list-section pt-80 pb-80">
            <div className="container">
                <div className="row">
                    {data.lso_features && data.lso_features.map((row,index) => 
                    <div className="col-lg-4 col-md-6 mb-4 mb-lg-0" key={index}>
                        <div className="list-box d-flex align-items-center">
                            <div className="list-icon">
                                <i className={row.ico_icon}></i>
                            </div>
                            <div className="content">
                                <h3>{row.txt_name}</h3>
                                <p>{row.txt_note}</p>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div>
     );
}

export default Features;